import { useState } from "react";
import { GuardianBadge } from "./GuardianBadge";

export const RuleRow = ({ label, status, manifestText, evidenceText }) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      data-testid="access-studio-rule-row"
      style={{
        border: "1px solid #e2e5ea",
        borderRadius: "8px",
        padding: "0.55rem 0.75rem",
        marginBottom: "0.4rem",
        background: "#fff",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "0.75rem" }}>
        <span style={{ fontSize: "0.85rem", fontWeight: 500 }}>{label}</span>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <GuardianBadge status={status} />
          <button
            data-testid="access-studio-rule-row-toggle"
            onClick={() => setOpen((value) => !value)}
            type="button"
            style={{
              border: "1px solid #d1d5db",
              background: "transparent",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "0.72rem",
              padding: "0.15rem 0.5rem",
            }}
          >
            {open ? "Hide proof" : "Show proof"}
          </button>
        </div>
      </div>
      {open && (
        <dl
          data-testid="access-studio-rule-row-detail"
          style={{ margin: "0.5rem 0 0", fontSize: "0.78rem", color: "#374151" }}
        >
          <dt style={{ fontWeight: 600 }}>Declared (manifest)</dt>
          <dd style={{ margin: "0 0 0.35rem" }}>{manifestText || "—"}</dd>
          <dt style={{ fontWeight: 600 }}>Extracted (evidence)</dt>
          <dd style={{ margin: 0 }}>{evidenceText || "—"}</dd>
        </dl>
      )}
    </div>
  );
};

export default RuleRow;
